export const SET_TASK_MODULE = "SET_TASK_MODULE"
export const RESET_TASK_MODULE = "RESET_TASK_MODULE"
export const ADD_SUBTASK = "ADD_SUBTASK"
export const REMOVE_SUBTASK = "REMOVE_SUBTASK"

export interface setTaskModule {
    type: typeof SET_TASK_MODULE;
    payload: any; 
}